<template>
    <Card
        icon="fas fa-file-alt"
        bg-color="tw:bg-[var(--sitecolor)]"
        title-color="white"
        title-classes="tw:border-b tw:border-gray-200"
        :title="'Textos y documentación'"
        padding="0"
    >
        <div class="tw:p-6 tw:space-y-6">
            <div>
                <label class="tw:block tw:text-gray-500 tw:mb-1">{{ 'Descripción' }}</label>
                <QuillEditor
                    ref="editorSynopsis"
                    :value="localData.synopsis"
                    @input="val => localData.synopsis = val"
                />
            </div>

            <div class="tw:border-t tw:border-gray-100"></div>

            <div>
                <label class="tw:block tw:text-gray-500 tw:mb-1">{{ 'Condiciones para Acreditaciones' }}</label>
                <QuillEditor
                    ref="editorCondicionesAcreditaciones"
                    :value="localData.condiciones_acreditaciones"
                    @input="val => localData.condiciones_acreditaciones = val"
                />
            </div>

            <div class="tw:border-t tw:border-gray-100"></div>

            <div>
                <ValidationProvider name="underage_policy" v-slot="{ errors }">
                    <label class="tw:block tw:text-gray-500 tw:mb-1">{{ 'Política de menores' }}</label>
                    <QuillEditor
                        ref="editorUnderagePolicy"
                        :value="localData.underage_policy"
                        @input="val => localData.underage_policy = val"
                    />
                    <span v-if="errors[0]" class="tw:text-xs tw:text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
    </Card>
</template>

<script setup>
    import { ref, inject } from 'vue';
    import Card from '@/modules/admin/ui/Card.vue';
    import QuillEditor from '@/modules/ui/QuillEditor.vue';

    const localData = inject('eventoFormData');

    const editorSynopsis = ref(null);
    const editorCondicionesAcreditaciones = ref(null);
    const editorUnderagePolicy = ref(null);

    defineExpose({
        editorSynopsis,
        editorCondicionesAcreditaciones,
        editorUnderagePolicy
    });
</script>
